<ul class="rating">
  <li *ngFor="let rating of ratings"><i [ngClass]="getStyle(rating)"></i></li>
  <li>&nbsp;({{avaliacoes}})</li>
</ul>
